import DefaultPrices from '../DefaultPrices';
import PromoCodePrices from '../PromoCodePrices';

import type { FC, HTMLAttributes } from 'react';

interface PricesProps extends HTMLAttributes<HTMLDivElement> {
  isPromoCode?: boolean;
}

const Prices: FC<PricesProps> = (props) => {
  const { isPromoCode, ...restProps } = props;

  return <div {...restProps}>{isPromoCode ? <PromoCodePrices /> : <DefaultPrices />}</div>;
};

export default Prices;
